export const SURFACE_LEVELS = [1, 2, 3, 4, 5, 6, 7, 8] as const;

export type SurfaceLevel = (typeof SURFACE_LEVELS)[number];

export function clampSurfaceLevel(value: number): SurfaceLevel {
  if (!Number.isFinite(value)) {
    return 1;
  }

  const level = Math.trunc(value);

  if (level <= 1) {
    return 1;
  }
  if (level >= 8) {
    return 8;
  }

  return SURFACE_LEVELS[level - 1] ?? 1;
}
